var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"human-date"},[_vm._v(_vm._s(_vm.getDateString()))])
}
var staticRenderFns = []

export { render, staticRenderFns }